import { Autocomplete, Box, ListItem, TextField, Typography } from '@mui/material'
import { StowageInstructionDto } from '@planning/app/api'
import { StowageInstructionAutocompleteViewStore } from '@planning/stores/stowageInstruction/StowageInstructionAutocompleteViewStore'
import { useTranslate } from '@tolgee/react'
import { FieldStore } from '@tom-ui/utils'
import { Observer, observer } from 'mobx-react-lite'
import { useEffect } from 'react'

interface StowageInstructionAutocompleteprops {
  fieldStore: FieldStore<StowageInstructionDto | null | undefined>
  required?: boolean
  autoCompleteStore: StowageInstructionAutocompleteViewStore
}

export const StowageInstructionsAutocomplete = observer(
  ({ fieldStore, required, autoCompleteStore }: StowageInstructionAutocompleteprops) => {
    const { t } = useTranslate()

    useEffect(() => {
      autoCompleteStore.fetchOptions()
    }, [autoCompleteStore.fetched])

    return (
      <Autocomplete
        data-cy='stowage-instructions-autocomplete'
        disableCloseOnSelect
        fullWidth
        options={autoCompleteStore.options}
        getOptionLabel={instruction => instruction.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        slotProps={{
          popper: {
            sx: { minWidth: '16rem' },
          },
        }}
        renderOption={(props, instruction) => (
          <ListItem {...props}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography variant='body2' data-cy={`stowage-instruction-${instruction.name}`}>
                {instruction.name}
              </Typography>
            </Box>
          </ListItem>
        )}
        defaultValue={fieldStore?.value}
        onChange={(_, value) => {
          fieldStore.setValue(value)
        }}
        renderInput={params => (
          <Observer>
            {() => (
              <TextField
                {...params}
                required={required}
                key={params.id}
                sx={{ marginTop: '1rem' }}
                label={`${t('specialStowage', 'Special Stowage')}`}
                error={!!fieldStore.error}
                helperText={fieldStore.error ? t('fieldIsRequired', 'Field is required.') : ''}
              />
            )}
          </Observer>
        )}
      />
    )
  },
)
